<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { logicHotCollectiveRank } from '@/logic/rank/relativeComplaint'

const props = withDefaults(defineProps<{
  seriesId: number | string
}>(), {

})

const {
  state,
  data,
  getRankData,
} = logicHotCollectiveRank()

getRankData({ seriesId: props.seriesId })
</script>

<template>
  <n-card
    title="相关投诉" embedded size="small" class="rounded-md"
    header-style="--n-title-font-weight: bold; --n-padding-bottom: 0.25rem"
  >
    <template #header-extra>
      <NuxtLink :to="APP_ROUTER.complaintList()">
        更多<i class="i-material-symbols:keyboard-double-arrow-right text-4" />
      </NuxtLink>
    </template>
    <UtilLoadState :state="state" :reload-handler="() => getRankData({ seriesId: props.seriesId })">
      <template v-if="data && data.length">
        <NuxtLink
          v-for="(v, i) in data" :key="i"
          class="mb-1 text-4.25 last:mb-0 line-clamp-1 hover:text-orange-6"
          :to="APP_ROUTER.complaintDetail(v.id)"
        >
          {{ v.title }}
        </NuxtLink>
      </template>
      <BasicEmpty v-else />
    </UtilLoadState>
  </n-card>
</template>

<style lang='scss' scoped>
</style>
